import React from 'react'
import { Card } from 'primereact/card'

export default function CustomCard({
  children,
  valueStyle,
  title = 'Title',
  subTitle = null,
  style = {},
}) {
  return (
    <Card title={title} subTitle={subTitle} style={style}>
      <div className="text-center">
        <span style={valueStyle}>{children}</span>
      </div>
    </Card>
  )
}
